export class WebhookV1NotificationTargetChangeArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policyId",
            "baseName": "policyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "policyName",
            "baseName": "policyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "userName",
            "baseName": "userName",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1NotificationTargetChangeArguments.attributeTypeMap;
    }
    constructor() {
    }
}
